
import { Component, Vue, Prop } from 'vue-property-decorator';

/**
 * Emits:
 * - ok (no payload): when user confirms
 */
@Component
export default class FileUploadStatus extends Vue {
  @Prop({ required: true }) reason!: { title: string; description: string[] };
}
